package music.jammers.client.shared.event.track.domain.validator

import music.jammers.client.shared.event.domain.model.ValidationError
import music.jammers.client.shared.event.domain.model.ValidationErrorValue
import music.jammers.client.shared.event.track.domain.usecase.ValidateEventTrackUseCase
import music.jammers.client.shared.event.track.presentation.model.UpdateInstrument

class EventTrackFieldValidator {

    fun validate(name: String, value: String): ValidationError? {
        val error = when (name) {
            ValidateEventTrackUseCase.TRACK_NAME,
            ValidateEventTrackUseCase.ARTIST_NAME -> emptyValidateString(name, value)

            else -> null
        }

        return error
    }

    fun validate(instrumentList: List<UpdateInstrument>): ValidationError? {
        val filtered = instrumentList.filter { item -> item.status.value != UpdateInstrument.Status.NOT_REQUIRED }

        return if (filtered.isEmpty()) {
            ValidationError(
                ValidateEventTrackUseCase.SELECTED_INSTRUMENTS,
                ValidationErrorValue.ItemNotSelected
            )
        } else {
            null
        }
    }

    private fun emptyValidateString(name: String, value: String): ValidationError? =
        if (value.isEmpty()) {
            ValidationError(name, ValidationErrorValue.EmptyValue)
        } else {
            null
        }
}